module.exports = __webpack_public_path__ + "static/advanced features-voice shift-3239c83d20b726cb0a6df83c4044426c.png";